import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid-item fill-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cluster = _resolveComponent("Cluster")!
  const _component_RecycleScroller = _resolveComponent("RecycleScroller")!

  return (_openBlock(), _createBlock(_component_RecycleScroller, {
    ref: "recycler",
    tabindex: "1",
    "type-field": "cluster_type",
    "key-field": "cluster_id",
    class: _normalizeClass(["grid-recycler hide-scrollbar-mobile", _ctx.classList]),
    items: _ctx.clusters,
    skipHover: true,
    buffer: 400,
    itemSize: _ctx.height,
    itemSecondarySize: _ctx.width,
    gridItems: _ctx.gridItems,
    onResize: _ctx.resize
  }, {
    before: _withCtx(() => [
      _renderSlot(_ctx.$slots, "before", {}, undefined, true)
    ]),
    default: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Cluster, {
          data: item,
          link: _ctx.link,
          counters: _ctx.counters,
          onClick: ($event: any) => (_ctx.click(item))
        }, null, 8, ["data", "link", "counters", "onClick"])
      ])
    ]),
    _: 3
  }, 8, ["class", "items", "itemSize", "itemSecondarySize", "gridItems", "onResize"]))
}